document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll("section[data-section]");
  for (let section of sections) {
    let sectionTitle = document.createElement("aside");
    let sectionText = document.createElement("span");
    let textColor = section.getAttribute("data-color") || "#A50931";
    let backgroundColor =
      getComputedStyle(section).backgroundColor || "#FFFFFF";
    let sectionHeight = section.offsetHeight;
    if (sectionHeight < 600) {
      sectionHeight = 540;
      section.style.minHeight = "600px";
    }

    let line = document.createElement("div");
    line.classList.add("line");

    sectionTitle.style.width = sectionHeight + "px";

    sectionText.innerHTML = section.getAttribute("data-section");
    sectionText.style.color = textColor;
    sectionText.style.backgroundColor =
      backgroundColor != "rgba(0, 0, 0, 0)" ? backgroundColor : "#FFFFFF";

    sectionTitle.classList.add("section-title");
    sectionTitle.appendChild(sectionText);
    sectionTitle.appendChild(line);
    section.appendChild(sectionTitle);

    window.setTimeout(function () {
      anime({
        targets: sectionTitle,
        translateX: ["-100px", "60px"],
        rotate: ["90deg", "90deg"],
        opacity: [0, 1],
      });
    }, 1000);
  }
});
